import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconUser = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-user"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="none"
    className={clsxm('text-primary-intense size-16 shrink-0', className)}
    {...props}
  >
    <path
      d="M44.3125 21.7778C44.3125 24.305 43.5611 26.7754 42.1532 28.8767C40.7454 30.978 38.7443 32.6158 36.4031 33.5829C34.062 34.55 31.4858 34.8031 29.0004 34.31C26.515 33.817 24.2321 32.6 22.4402 30.813C20.6483 29.026 19.4281 26.7492 18.9337 24.2706C18.4393 21.792 18.693 19.2228 19.6628 16.8879C20.6325 14.5531 22.2748 12.5575 24.3818 11.1534C26.4888 9.7494 28.9659 9 31.5 9C34.8981 9 38.157 10.3462 40.5598 12.7425C42.9626 15.1388 44.3125 18.3889 44.3125 21.7778ZM34.0625 34.5556H28.9375C24.1802 34.5556 19.6177 36.4403 16.2538 39.7951C12.8898 43.1499 11 47.7 11 52.4444V52.4444C11 53.1222 11.27 53.7722 11.7505 54.2515C12.2311 54.7308 12.8829 55 13.5625 55H49.4375C50.1171 55 50.7689 54.7308 51.2495 54.2515C51.73 53.7722 52 53.1222 52 52.4444C52 47.7 50.1102 43.1499 46.7462 39.7951C43.3823 36.4403 38.8198 34.5556 34.0625 34.5556V34.5556Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
